import { Vehicle } from "../Interfaces/vehicle.type";

export const mapPurchasesData = ({ results }): { vehicles: Vehicle[] } => {
  const vehicles = results.map((vehicle) => ({
    isCentralOffsiteLocation: vehicle.isCentralOffsiteLocation,
    vehicleIdentifier: vehicle.saleResultItemIdentifier,
    lotNumber: vehicle.lotNumber,
    vrm: vehicle.vrm,
    vin: vehicle.vin,
    vehicleType: vehicle.vehicleType,
    hasImages: vehicle.hasImages,
    generateImagesZipFileUrl: vehicle.generateImagesZipFileUrl,
    masterImageUrl: vehicle.masterImageUrl,
    bidAmount: vehicle.bidAmount,
    vatType: vehicle.vatType,
    paymentStatus: vehicle.invoiceType,
    primaryVehicleDescription: vehicle.primaryVehicleDescription,
    secondaryDescription: vehicle.secondaryDescription,
    saleCode: vehicle.saleCode,
    inventoryId: vehicle.inventoryId,
    bidTimestamp: vehicle.bidTimestamp,
    invoice: vehicle.invoice,
    delivery: vehicle.delivery,
    isEligibleForDelivery: vehicle.delivery?.isEligible || false,
    isExport: vehicle.delivery?.isExport,
    isOrderReferenceAdded: vehicle.delivery?.isOrderReferenceAdded || false,
    orderReference: vehicle.delivery?.orderReference || null,
    orderState: vehicle.delivery?.orderState || null,
    isBookedForCollection: vehicle.isBookedForCollection || false,
    collectionStartDate: vehicle.collection?.startDate || null,
    collectionEndDate: vehicle.collection?.endDate || null,
    isVehicleOffsited: vehicle.isVehicleOffsited,
    saleDate: vehicle.saleDate || null,
    location: vehicle.location || null,
    logBookPresent: vehicle.logBookPresent,
    saleSection: vehicle.saleTitle || null,
    mileage: vehicle.mileage || null,
    mileageWarranted: vehicle.mileageWarranted,
    color: vehicle.bodyColour || null,
    transmission: vehicle.gearboxType || null,
    fuel: vehicle.fuelType || null,
    doors: vehicle.numberOfDoors || null,
    grade: vehicle.grade || null,
    conditionReport:
      vehicle.reports.length > 0
        ? vehicle.reports?.find((report) => report.rel === "conditionreporturl")
        : null,
    mechanicalReport:
      vehicle.reports.length > 0
        ? vehicle.reports?.find(
            (report) => report.rel === "mechanicalreporturl"
          )
        : null,
  }));

  return {
    vehicles,
  };
};
